/** @file entryRect: the sheet rect of a tile of a facet entry, with the transposed extendX layout (18.5). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';

/**
 * `[x, y, w, h]` of tile `tile` on the entry's sheet: `[ox + tile * w, oy, w, h]`, or `[ox, oy + tile * h, w, h]`
 * with `extendX`; `[0, 0, 0, 0]` for tile -1. Writes `out` and returns it.
 */
export function entryRect(entry: FacetEntry, tile: number, out: [number, number, number, number]): typeof out {
  const [ox, oy] = entry.origin;
  const [w, h] = entry.size;
  if (tile < 0) {
    out[0] = 0; out[1] = 0; out[2] = 0; out[3] = 0;
  } else {
    out[0] = entry.extendX === true ? ox : ox + tile * w;
    out[1] = entry.extendX === true ? oy + tile * h : oy;
    out[2] = w;
    out[3] = h;
  }
  return out;
}
